import JSONSerializer from '@ember-data/serializer/json';
import { underscore } from '@ember/string';

import ActiveModelSerializer from 'active-model-adapter/active-model-serializer';

// Restore serialization for hasMany relationships
// which is disabled by active-model-adapter
const { serializeHasMany } = JSONSerializer.proto();

export default class RegisterDocumentSerializer extends ActiveModelSerializer {
  serializeHasMany = serializeHasMany;

  modelNameFromPayloadKey() {
    return 'register-document';
  }

  keyForRelationship(key) {
    if (key === 'membership' || key === 'organization') {
      return 'subject_id';
    }

    return key;
  }

  payloadKeyFromModelName() {
    return 'document';
  }

  extractRelationship(relationshipModelName, relationshipHash) {
    if (
      relationshipModelName === 'register-stakeholder' ||
      relationshipModelName === 'register-organization'
    ) {
      return { id: relationshipHash, type: relationshipModelName };
    }

    return super.extractRelationship(...arguments);
  }

  keyForAttribute(attr) {
    return underscore(attr);
  }
}
